import { useAppConfig } from "~/app/config/useAppConfig";
import { type MouseEventHandler } from "react";
import { Button } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { STORE_FINDER } from "~/utils/url/staticUrls";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

interface ButtonProps {
  className?: string;
  onClick?: MouseEventHandler<HTMLElement>;
  href?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const AddToCartButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  const webservicesDisabled = useAppConfig()?.configuration.disableAllWS ?? false;
  const disabled = webservicesDisabled || props.disabled == null ? false : props.disabled;
  return (
    <Button startIcon={<ShoppingCartIcon />} data-test-id={"btn-add-to-cart"} disabled={disabled} {...props}>
      {t("page.wishlist.action.addSelected")}
    </Button>
  );
};

interface RequestOfferButtonProps {
  selectedEntryIds: string[];
  wishlistId: string;
}
export const RequestOfferButton = (props: ButtonProps & RequestOfferButtonProps) => {
  const { t } = useTranslation();
  const { wishlistId, selectedEntryIds } = props;
  const params = new URLSearchParams();
  params.set("wl-id", wishlistId);
  params.set("wl-entry-ids", selectedEntryIds.join(","));

  return (
    <Button
      href={STORE_FINDER + "?" + params.toString()}
      data-test-id={"btn-request-offer"}
      disabled={selectedEntryIds.length === 0}
      {...props}
    >
      {t("page.wishlist.button.requestOffer")}
    </Button>
  );
};
